export const getCookie = (name: string): string =>
  typeof document !== 'undefined'
    ? document.cookie.split('; ').reduce((r, v) => {
        const parts = v.split('=');
        return parts[0] === name ? decodeURIComponent(parts[1]) : r;
      }, '')
    : '';
